<template>
  <section class="section" id="services">
    <br>
    <br>
    <div class="container">
      <img :class="[{'b-english': $i18n.locale === 'en'}, 'b-title']" :src="require(`../assets/titles/${$i18n.locale}/services.jpg`)" alt="Leistungen">
      <b-divider></b-divider>
      <br>
      <br>
      <div class="columns">
        <div class="column box b-hosting">
          <fal class="fa-5x">
            <fa class="has-text-orange" :icon="['far', 'circle']"></fa>
            <fa icon="server" transform="shrink-8"></fa>
          </fal>
          <h4 class="title is-4">{{$t('hosting.title')}}</h4>
          <h6 class="title is-7">{{$t('hosting.subtitle')}}</h6>
          <div class="content">
            <ul>
              <li>{{$t('hosting.1')}}</li>
              <li>{{$t('hosting.2')}}</li>
              <li>{{$t('hosting.3')}}</li>
              <li>{{$t('hosting.4')}}</li>
            </ul>
          </div>
        </div>
        <div class="column box b-support">
          <fal class="fa-5x">
            <fa class="has-text-orange" :icon="['far', 'circle']"></fa>
            <fa icon="handshake" transform="shrink-8 left-2"></fa>
          </fal>
          <h4 class="title is-4">{{$t('support.title')}}</h4>
          <h6 class="title is-7">{{$t('support.subtitle')}}</h6>
          <div class="content">
            <ul>
              <li>{{$t('support.1')}}</li>
              <li>{{$t('support.2')}}</li>
              <li>{{$t('support.3')}}</li>
              <li>{{$t('support.4')}}</li>
            </ul>
          </div>
        </div>
        <div class="column box b-development">
          <fal class="fa-5x">
            <fa class="has-text-orange" :icon="['far', 'circle']"></fa>
            <fa icon="code" transform="shrink-8 left-2"></fa>
          </fal>
          <h4 class="title is-4">{{$t('development.title')}}</h4>
          <h6 class="title is-7">{{$t('development.subtitle')}}</h6>
          <div class="content">
            <ul>
              <li>{{$t('development.1')}}</li>
              <li>{{$t('development.2')}}</li>
              <li>{{$t('development.3')}}</li>
              <li>{{$t('development.4')}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BDivider from '@/components/BDivider.vue';

export default {
  name: 'BServices',
  components: {
    BDivider,
  },
}
</script>

<style lang="scss" scoped>
  .content {
    font-size: .9em;
  }

  .b-title {
    margin-bottom: 0;
  }

  .b-development {
    margin-left: .5em;
    margin-bottom: 1.5em;
    padding-bottom: 1em;
  }

  .b-support {
    margin-right: .5em;
    margin-left: .5em;
  }

  .b-hosting {
    margin-right: .5em;
  }

  .container {
    text-align: center;
    padding-right: .75em;
    padding-left: .75em;
  }

  .notification {
    background-color: transparent;
    padding: 1em;
  }

  h6 {
    min-height: 2em;
  }

  h4 {
    margin-top: 1em;
  }

  ul {
    list-style: none !important;
    margin: 0 !important;
  }

  .b-english {
    margin-bottom: .4em;
    width: 150px;
  }
</style>
